<script lang="ts" setup>
import PageTitle from './PageTitle.vue'

interface Props {
  title: string
  subtitle?: string
  eyebrow?: string
  tag?: 'h1' | 'h2' | 'h3'
}

withDefaults(defineProps<Props>(), {
  subtitle: undefined,
  eyebrow: undefined,
  tag: 'h2',
})
</script>

<template>
  <header class="flex flex-col items-center text-center mb-12 lg:mb-16">
    <span
      v-if="eyebrow"
      class="uppercase font-semibold text-success-500 tracking-wider text-sm mb-3"
    >
      {{ eyebrow }}
    </span>
    <PageTitle :tag="tag" :title="title" />
    <p v-if="subtitle" class="text-lg text-muted-color max-w-2xl mt-4">{{ subtitle }}</p>
  </header>
</template>
